import { createFileRoute } from "@tanstack/react-router";

import { parseOrderSearch } from "@/features/orders";
import { OrderPage } from "@/features/orders/pages";
import { strictSearch } from "@/shared/lib/search";

export const Route = createFileRoute("/_app/orders/$orderId")({
  validateSearch: strictSearch(parseOrderSearch),
  component: Order,
});

function Order() {
  const { orderId } = Route.useParams();
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  // Keyed by the order: going from one order to another starts the page anew.
  return (
    <OrderPage
      key={orderId}
      orderId={orderId}
      begin={search.do}
      // What the page was opened to do is asked once: the address forgets it.
      onBegun={() => void navigate({ search: {}, replace: true })}
    />
  );
}
